export default __webpack_public_path__ + "static/hexagon_w.dd4897c62128f14c01dfbde681d4ea8b.png";